module.exports = __webpack_public_path__ + "img/card3.2862e514.png";